<template>
  <div :data-title="$t('VEHICLE_TITLE')" class="flex flex-col gap-2">
    <span class="float-right" :class="type">
      {{ $i18n.locale == 'fa' ? vehicle.fa_title : vehicle.en_title }}
      <span v-if="color != null" class="mx-1">
        {{ $i18n.locale == 'fa' ? color.fa_title : color.en_title }}
      </span>
    </span>
    <div class="text-xs mr-2 md:mr-0 license_plate" :class="type">
      <span>{{ fist }}</span>
      <span class="text-blue-500 mx-2 font-bold">|</span>
      <span>{{ two }}</span>
      <span class="mx-2">{{ char }}</span>
      <span>{{ license_plate.substring(0, 2) }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    license_plate: {
      type: String,
      default: '210122222',
    },
    vehicle: {
      type: Object,
      required: false,
      default: () => ({
        fa_title: '',
        en_title: '',
      }),
    },
    chars: {
      type: Array,
      required: true,
      default(rawProps) {
        return [
          {
            char: '',
            code: '',
          },
        ]
      },
    },
    color: {
      type: Object,
      required: false,
    },
    type: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      license: this.license_plate,
    }
  },
  computed: {
    fist() {
      return this.license.substring(7, 9)
    },
    two() {
      return this.license.substring(4, 7)
    },
    char() {
      return this.chars.find((i) => i.code == this.license.substring(2, 4)) !=
        undefined
        ? this.chars.find((i) => i.code == this.license.substring(2, 4)).char
        : ''
    },
  },
  watch: {
    license_plate(val) {
      this.license = val
    },
  },
}
</script>
<style lang="scss" scoped>
.float-right.dashboard {
  text-align: center;
}
@media (max-width: 600px) {
  .license_plate:not(.dashboard) {
    width: 100%;
    padding-right: 35%;
  }
}
</style>
